import shopAppInit from '@/components/app';

document.addEventListener('DOMContentLoaded', () => {
  shopAppInit();
});
